// Escalones de margen del tab Rentabilidad: UNA sola lista con la identidad
// de cada uno (label, color por token del tema) y sus dos claves, porque los
// mismos escalones llegan por dos caminos:
//
// - `rowKey`: la fila del store `financialReports` (estructura del plan de
//   cuentas) que consumen el gráfico y la tabla del tab.
// - `metricKey`: la clave del backend en `/profitability/comparison` y en
//   `evolution.metrics` del drawer de categorías (`MARGIN_METRICS` de
//   `profitability_comparison.py`).
//
// El color se fija por escalón, nunca por índice: un plan sin Costos de
// Productos no tiene Producto, uno sin Costos Fijos no tiene Contribución, y
// los demás conservan su color (Servicios: Bruto, EBITDA y Neto). Puro, sin
// reactividad: lo consumen la card del tab y la evolución por ítem del drawer.
export const PROFITABILITY_MARGINS = Object.freeze([
	Object.freeze({
		rowKey: "margen_producto",
		metricKey: "margen_producto",
		label: "Margen Producto",
		shortLabel: "Producto",
		colorToken: "--report-chart-line-1",
	}),
	Object.freeze({
		rowKey: "margen_bruto",
		metricKey: "margen_bruto",
		label: "Margen Bruto",
		shortLabel: "Bruto",
		colorToken: "--report-chart-line-2",
	}),
	Object.freeze({
		rowKey: "margen_contribucion",
		metricKey: "margen_contribucion",
		label: "Margen Contribución",
		shortLabel: "Contribución",
		colorToken: "--report-chart-line-3",
	}),
	Object.freeze({
		rowKey: "margen_EBITDA_%",
		metricKey: "margen_ebitda",
		label: "Margen EBITDA",
		shortLabel: "EBITDA",
		colorToken: "--report-chart-line-4",
	}),
	Object.freeze({
		rowKey: "margen_neto_%",
		metricKey: "margen_neto",
		label: "Margen Neto",
		shortLabel: "Neto",
		colorToken: "--report-chart-line-5",
	}),
]);

/** Escalón por su clave del backend (`margen_ebitda`), o `undefined`. */
export function marginByMetricKey(metricKey) {
	return PROFITABILITY_MARGINS.find((margin) => margin.metricKey === metricKey);
}
